import { render, staticRenderFns } from "./NotableIndividualResult.vue?vue&type=template&id=7c894788&scoped=true"
import script from "./NotableIndividualResult.vue?vue&type=script&lang=js"
export * from "./NotableIndividualResult.vue?vue&type=script&lang=js"
import style0 from "./NotableIndividualResult.vue?vue&type=style&index=0&id=7c894788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c894788",
  null
  
)

export default component.exports